import { postAPI } from 'framework/api/http';
import { useMutation } from 'react-query';

interface VerifyOTPWithRegisterInterface {
  data: string;
  serverRef: string;
  name: string;
}

export const useVerifyOTPWithRegister = () => {
  const mutate = useMutation(({ data, serverRef, name }: VerifyOTPWithRegisterInterface) => {
    return postAPI('/creator-api/verify_otp_with_reg', {
      data,
      serverRef,
      username: name,
    });
  });

  return mutate;
};

export default useVerifyOTPWithRegister;
